function getType(obj) {
	return Object.prototype.toString.call(obj);
}

function isArray(obj) {
	return getType(obj) === "[object Array]";
}

function isObject(obj) {
	return getType(obj) === "[object Object]";
}

function isString(obj) {
	return getType(obj) === "[object String]";
}

function isNumber(obj) {
	return getType(obj) === "[object Number]";
}

function isDate(obj) {
	return getType(obj) === "[object Date]";
}

function isReExp(obj) {
	return getType(obj) === "[object RegExp]";
}

function isFunction(obj) {
	return getType(obj) === "[object Function]";
}

function isBoolean(obj) {
	return getType(obj) === "[object Boolean]";
}

function isUndefined(obj) {
	return getType(obj) === "[object Undefined]";
}

function deepCopy(obj) {
	var result = null;

	if (isArray(obj)) {

		result = [];

	} else if (isObject(obj)) {

		result = {};

	} else if (isDate(obj)) {

		result = new Date(obj.toJSON());

	} else if (isReExp(obj)) {

		result = new RegExp(obj.valueOf());

	} else {

		result = obj;

	}

	for (var key in obj) {

		if (obj.hasOwnProperty(key)) {

			var child = obj[key];

			if (isObject(child) ||
				isArray(child)) {
				result[key] = deepCopy(child)
			}

			if (isFunction(child) ||
				isDate(child) ||
				isString(child) ||
				isNumber(child) ||
				isBoolean(child) ||
				isReExp(child)) {

				result[key] = child;
			}

		}
	}

	return result;
}

function extend(dest, src) {

	if (getType(dest) !== getType(src)) {

		return deepCopy(dest);

	}

	if (isFunction(dest) ||
		isDate(dest) ||
		isBoolean(dest) ||
		isNumber(dest) ||
		isString(dest) ||
		isReExp(dest) ||
		isUndefined(dest)
	) {

		return deepCopy(dest);

	}

	var result = deepCopy(dest);

	for (var key in src) {
		if (src.hasOwnProperty(key)) {
			var child = src[key];

			if (isObject(child) ||
				isArray(child)) {
				result[key] = extend(result[key] || {}, child);
			} else {

				result[key] = src[key];

			}
		}

	}

	return result;

}

function strArrayIndexOf(arr, item) {
	var index = -1;
	for (var i = 0; i < arr.length; i++) {
		if (item === arr[i]) {
			index = i;
			break;
		}
	}
	return index;
}
/*
	去除src字符串数组中, omit包含的元素,
*/
function strArrayOmit(src, omit) {
	var arr = deepCopy(src);
	for (var i = 0; i < omit.length; i++) {
		for (var j = 0; j < arr.length; j++) {
			if (arr[j] == omit[i]) {
				arr.splice(j, 1);
				--j;
			}
		}
	}
}

/**
 * @desc 比较字面量对象是否包含同样的信息，值一定是字符串
 */
function isObjectEquals(a, b) {
	let flag = true;
	for (let i in a) {
		if (b[i] !== a[i]) {
			flag == false;
			break;
		}
	}

	return flag;
}

/**
 * @desc 去除字符串两边的空格
 * @param {String} str 
 */
function trim(str) {
	if (str === null) {
		str = "null"
	}
	str = str.toString();
	str = str.replace(/^\s+|\s+$/g, '');
	return str;
}


/**
 * @desc 格式化时间
 * @param {Date} date 
 */
function formatDate(date) {
	if(!date) {
		return "";
	}
	let dateStr;
	let oDate;
	let flag = Object.prototype.toString.call(date) === "[object Date]";
	if(!flag) {
		oDate = new Date(date);
	} else {
		oDate = date;
	}
	let y = oDate.getFullYear();
	let m = oDate.getMonth() + 1;
	let d = oDate.getDate();
	let h = oDate.getHours();
	let min = oDate.getMinutes();
	let s = oDate.getSeconds();
	// dateStr = `${oDate.getFullYear()}-${oDate.getMonth() + 1}-${oDate.getDate()} ${oDate.getHours()}:${oDate.getMinutes()}:${oDate.getSeconds()}`;
	dateStr = `${y}-${m<10 ? '0'+m : m}-${d<10 ? '0'+d : d} ${h<10 ? '0'+h : h}:${min<10 ? '0'+min : min}:${s<10 ? '0'+s : s}`;
	return dateStr;
}

let sessionStore = {
	set: function (key, value) {
		window.sessionStorage.setItem(key, value);
	},
	get: function (key, defaultValue) {
		return window.sessionStorage.getItem(key) || defaultValue;
	},
	setObject: function (key, value) {
		window.sessionStorage.setItem(key, JSON.stringify(value));
	},
	getObject: function (key) {
		return JSON.parse(window.sessionStorage.getItem(key) || '{}');
	},
	remove: function (key) {
		window.sessionStorage.removeItem(key);
	},
	clear: function () {
		window.sessionStorage.clear();
	}
};

//打开新网页
let openInNewWindow = function(url) {
	if (navigator.userAgent.indexOf('Chrom') > -1) {
		let a = document.createElement("a");
		a.setAttribute('target', '_blank');
		a.setAttribute('href', url);
		a.click();
	} else {
		window.open(url);
	}
}

export {
  trim,
  isObjectEquals,
  deepCopy,
  extend,
  strArrayIndexOf,
  strArrayOmit,
  formatDate,
  sessionStore,
  openInNewWindow
};